module.exports = __webpack_public_path__ + "static/media/icon-instagram.5620f96d.svg";